import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import PrimaryApproval from '../../features/compensation/primaryApproval/PrimaryApproval';
import ScoreCardRoles from '../../features/compensation/scoreCardRoles/ScoreCardRoles';
import StatusDetail from '../../features/compensation/statusDetail/StatusDetail';
import './primaryApprovalScorecardStatus.scss';
import PrimaryApprovalDefault from '../../features/compensation/primaryApprovalDefault/PrimaryApprovalDefault';

type primaryApprovalScorecardStatusProps = {
    inputScorecardVersion: number;
    inputYear: number;
    inputMonth: number;
    inputReadonly: boolean;
    via?: string;
};

export const PrimaryApprovalScorecardStatus = ({
    inputYear,
    inputMonth,
    inputScorecardVersion,
    inputReadonly,
    via,
}: primaryApprovalScorecardStatusProps) => {
    return (
        <div className="card shadow border-0 my-4 borderRadius10">
            <div className="card-body">
                {/* <PayRulesAgentDropDown />

                <div className="row">
                    <div className="col-md-2">
                        <PayRulesQualifers />
                    </div>
                    <div className="col-md-4 ps-1">
                        <PayRules />
                    </div>
                </div> */}

                <div className="row row-cols-1 row-cols-md-3 g-4 mt-1 scorcardStatusColumns mb-3">
                    <div className="col firstColumn">
                        <TabView>
                            <TabPanel header="Primary Approval">
                                <PrimaryApproval
                                    inputYear={inputYear}
                                    inputMonth={inputMonth}
                                    inputScorecardVersion={inputScorecardVersion}
                                    inputReadonly={inputReadonly}
                                    via={via}
                                />
                            </TabPanel>
                            <TabPanel header="Defaults">
                                <PrimaryApprovalDefault
                                    inputYear={inputYear}
                                    inputMonth={inputMonth}
                                    inputScorecardVersion={inputScorecardVersion}
                                    inputReadonly={inputReadonly}
                                    via={via}
                                />
                            </TabPanel>
                        </TabView>
                    </div>
                    <div className="col nextColumn">
                        <StatusDetail
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    </div>
                    <div className="col nextColumn">
                        <ScoreCardRoles
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
